export default __webpack_public_path__ + "static/media/triviamaster.a3989b0c.png";